import React from 'react'
import { Redirect, Route } from 'react-router'

import App from 'containers/App'
import CreateEventContainer from 'containers/event/CreateEvent/CreateEvent'
import EventListContainer from 'containers/event/EventList/EventListContainer'
import TimePollDetail from 'containers/time-poll/TimePollContainer/TimePoll/TimePollDetail/TimePollDetail'
import CreateTimePoll from 'containers/time-poll/TimePollContainer/TimePoll/CreateTimePoll/CreateTimePoll'
import LoginContainer from './containers/time-poll/panels/LoginContainer'
import TimePollContainer from 'containers/time-poll/TimePollContainer/TimePollContainer'
import CreateSignUp from 'containers/time-poll/TimePollContainer/SignUp/CreateSignUp/CreateSignUp'
import SignUpDetail from 'containers/time-poll/TimePollContainer/SignUp/SignUpDetail/SignUpDetail'
import EditSignUp from 'containers/time-poll/TimePollContainer/SignUp/CreateSignUp/EditSignUp/EditSignUp'
import EditEventContainer from 'containers/event/EditEvent/EditEventContainer'

export default (
  <Route path="/">
    <Route path="e/create" component={CreateEventContainer} />
    <Route path="e/list" component={EventListContainer} />
    <Route path="e/edit(/:eventToken)" component={EditEventContainer} />
    <Route path="e/:eventToken(/:invitationToken)(:/)" component={App}>
      <Route path="/details" />
      <Route path="/date" />
      <Route path="/venue" />
      <Route path="/guests" />
      <Route path="/comments" />
      <Route path="/media" />
      <Route path="/orders" />
      <Route path="/orderDetail" />
      <Route path="/requestRefund" />
      <Route path="/settings" />
      <Route path="/share" />
      <Route path="/rsvp">
        <Route path="/" />
        <Route path="/accept" />
        <Route path="/decline" />
      </Route>
      <Route path="/event_links" />
      <Route path="/join_meeting" />
      {/* <Redirect from="*" to="/" /> */}
    </Route>
    <Route path="a/:announcementToken" component={App}>
      <Redirect from="*" to="/a/:announcementToken" />
    </Route>
    <Route path="tp/create" component={CreateTimePoll} />
    <Route path="tp/timePoll" component={TimePollContainer} />
    <Route path="tp/login" component={LoginContainer} />
    <Route path="tp/:timePollToken(/:invitationToken)(:/)" component={TimePollDetail}>
      <Route path="/login" />
      <Route path="/successfull" />
      <Route path="/closed" />
      <Route path="/deleted" />
      <Redirect from="*" to="/" />
    </Route>
    <Route path="su/create" component={CreateSignUp} />
    <Route path="su/edit(/:invitationToken)" component={EditSignUp} />
    <Route path="su/:signUpToken(/:invitationToken)(:/)" component={SignUpDetail} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.jsx